import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import './PracticePerfectProgress.css';
import Header from '../../Header/Header';
import Spinner from '../../Spinner/Spinner';
import { post } from '../../../app/shared/http';
import PPVideoQuizProgress from './PPVideoQuizProgress';
import { handleException } from '../../../app/util/util';
import PPQuizCenterProgress from './PPQuizCenterProgress';
import PPConfidenceDashboard from './PPConfidenceDashboard';
import loaderColors1 from '../../Spinner/loaderColors1.gif';
import { withAuth, handleResponse, handleJwtTokenForKeppMeLoggedIn } from "../../../app/util/HOC";
export function PracticePerfectProgress() {
    const { isbn } = useParams();
    const userVO = JSON.parse(localStorage.getItem('userVO'));
    const ppIsbn = (isbn && isbn !== 'undefined') ? isbn : localStorage.getItem('bookIsbn');
    const [ppProgressPageInfo, setPpProgressPageInfo] = useState({});
    const [isPpProgressPageLoading, setIsPpProgressPageLoading] = useState(true);
    const [ppProgrViewMode, setPpProgrViewMode] = useState("confidenceDashBoard");
    const [ppProgrViewOptions, setPpProgrViewOptions] = useState([
        {
            "value": "confidenceDashBoard", "label": "Confidence Dashboard"
        },
        {
            "value": "quizCenterProgress", "label": "Quiz Center Progress"
        },
        {
            "value": "videoQuizProgress", "label": 'Video Quiz Progress'
        }
    ]);
    function getPPProgressPagedetails() {
        let reqData = { "productISBN": ppIsbn };
        post("/PP/get-PPproductDetails", reqData, 'qpAPI')
            .then(handleResponse)
            .then(response => response.json())
            .then(handleJwtTokenForKeppMeLoggedIn)
            .then(data => {
                if (data.Exception) {
                    handleException(data);
                    return false;
                } else {
                    if (data.ValidityStatus === "Expired") {
                        localStorage.setItem("PPException", data.ValidityStatus);
                        window.location.replace(window.location.origin + "/invalidUrl");
                        return false;
                    }
                    localStorage.removeItem('PPException');
                    setPpProgressPageInfo(data);
                    setIsPpProgressPageLoading(false);
                    localStorage.setItem("ppLandingInfo", JSON.stringify(data));
                    localStorage.setItem("ppProductName", data.ProductName);
                    localStorage.setItem("ppProductTagId", data.SATagId);
                }
            }).catch(error => {
                console.error("There has been a problem with your fetch operation:", error);
            });
    }
    useEffect(() => {
        getPPProgressPagedetails();
    }, []);
    return (
        <>
            <Spinner
                loading={isPpProgressPageLoading}
                imageSrc={loaderColors1}
                overlayBackground="rgba(0,0,0,0.5)"
            />
            <Header userVO={userVO} pageName="PPProgress" isbn={ppIsbn}></Header>
            <div className='container'>
                <div className="card ppProgressContainerSection">
                    <div className="card-body ppProgressContainerCard">
                        {
                            isPpProgressPageLoading === false ?
                                <>
                                    <div className="row">
                                        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 no-padding">
                                            <div className="ppProgressLogoContainer">
                                                <p>
                                                    <span className='ppProgressCommonStyle ppProgressLogoBoldText'>PracticePerfect<sup>TM</sup></span>
                                                    <span className='ppProgressCommonStyle ppProgressLogoText'>{ppProgressPageInfo.ProductName}</span>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row" >
                                        <div className="col-xl-8 col-lg-7 col-md-6 col-sm-12 col-xs-12 no-padding mt-3">
                                            <p className="ppProgressCommonStyle ppProgressTxt mb-3">{userVO.firstName}'s Progress</p>
                                        </div>
                                        <div className='col-xl-4 col-lg-5 col-md-6 col-sm-12 col-xs-12'>
                                            <div className="ppProgressSortByCont row">
                                                <div className="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 ppProgressViewLabel" >
                                                    <p className='ppProgressViewTxt' style={{ textAlign: 'left' }}>View:</p>
                                                </div>
                                                <div className="col-xl-10 col-lg-10 col-md-10 col-sm-10 col-10" style={{ paddingRight: '9px' }} >
                                                    <select data-testid="select_mode" className="ppProgressViewInput form-control" value={ppProgrViewMode} onChange={(e) => setPpProgrViewMode(e.target.value)}>
                                                        {
                                                            ppProgrViewOptions.map(ppProgrViewOpt => {
                                                                return (
                                                                    <option value={ppProgrViewOpt.value}>{ppProgrViewOpt.label}</option>
                                                                )
                                                            })
                                                        }
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        {
                                            ppProgrViewMode === 'confidenceDashBoard' ?
                                                <PPConfidenceDashboard ppProgrPageInfo={ppProgressPageInfo} /> :
                                                ppProgrViewMode === 'quizCenterProgress' ?
                                                    <PPQuizCenterProgress ppProgrPageInfo={ppProgressPageInfo} /> :
                                                    ppProgrViewMode === 'videoQuizProgress' ?
                                                        <PPVideoQuizProgress ppProgrPageInfo={ppProgressPageInfo} />
                                                        : null
                                        }
                                    </div>
                                </>
                                : null
                        }
                    </div>
                </div>
            </div>
        </>
    )
}
export default withAuth(PracticePerfectProgress);